import { ChgHost } from "./MessageTypes/Commands/ChgHost.mjs";
export var ChgHostCapability = {
    name: 'chghost',
    messageTypes: [ChgHost]
};
